import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {HOTB} from "../HOTB";
import {GameAssets} from "../GameAssets";
import {GameConfig} from "../GameConfig";
import {AnimUtils} from "../utils/AnimUtils";
import {gsap} from "gsap";

export class MultiBoard extends PIXI.Container implements StageLayer {
    private _board: PIXI.Sprite;
    private _prefix: string = "x";
    private _multText: PIXI.BitmapText;
    private _fontStyle: any = {
        fontName: GameAssets.GAME_MULTIPLIER,
        fontSize: 4
    };
    private _boardHighLight: PIXI.spine.Spine;

    constructor() {
        super();
        this.init();
    }

    public updateValue(value: number): void {
        this._multText.text = this._prefix + value;
    }

    public onSpinStart(): void {
        this.updateValue((HOTB.model.isPlayingBonusSpins) ? HOTB.model.data.gameMultiplierAfter : 1);
        GameConfig.TOTAL_GAME_MULTIPLIER = 0;
    }

    public onGameLoad(): void {
        this.updateValue(HOTB.model.data.gameMultiplierAfter);
    }

    public show(): void {
        this.visible = true;
    }

    public hide(): void {
        this.visible = false;
    }

    public showGlow(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        tl.add(AnimUtils.playSpineAnimation({
            spineObj: this._boardHighLight,
            animation: "trigger"
        }));

        return tl;
    }

    private init(): void {
        this.position.set(670, 172);
        this.createBoard();
        this.createMultiplier();
        this.createBoardHighLight();
    }

    private createBoard(): void {
        this._board = new PIXI.Sprite(HOTB.assetLoader.getTextures("gameMultBg")[0]);
        this._board.anchor.set(0.5);
        this._board.position.set(0);
        this.addChild(this._board);
    }

    private createMultiplier(): void {
        this._multText = new PIXI.BitmapText(this._prefix + "1", this._fontStyle);
        this._multText.anchor = new PIXI.Point(0.5, 0.5);
        this._multText.position.set(-3, 10);
        this._multText.alpha = 0.8;

        this.addChild(this._multText);
    }

    private createBoardHighLight(): void {
        this._boardHighLight = AnimUtils.createNewSpine({
            path: "multiBoardGlow",
            name: "multiBoardGlow",
            pos: new PIXI.Point(-5, 8),
            initShow: false
        });

        this.addChild(this._boardHighLight);
    }
}